var map = {
	"./AMLQuestionnaire/img-aml@2x.png": "5804",
	"./AMLQuestionnaire/img-aml@3x.png": "c7f7",
	"./CMHK/bg.png": "3d70",
	"./CMHK/logo.png": "5336",
	"./InvestmentEducation/01_zhCn.png": "f032",
	"./InvestmentEducation/01_zhTc.png": "70bb",
	"./InvestmentEducation/02_zhCn.png": "12a9",
	"./InvestmentEducation/02_zhTc.png": "51a7",
	"./InvestmentEducation/03_zhCn.png": "0d87",
	"./InvestmentEducation/03_zhTc.png": "f56a",
	"./InvestmentEducation/04_zhCn.png": "c65b",
	"./InvestmentEducation/04_zhTc.png": "bf64",
	"./InvestmentEducation/05_zhCn.png": "fb70",
	"./InvestmentEducation/05_zhTc.png": "61c0",
	"./InvestmentEducation/kf.png": "dd74c",
	"./PICertification/border_bg@2x.png": "b06e",
	"./PICertification/border_bg@3x.png": "d6d8",
	"./PICertification/border_bg_img@2x.png": "a402",
	"./PICertification/border_bg_img@3x.png": "ef86",
	"./PICertification/content_bg1@2x.png": "0f8a",
	"./PICertification/content_bg1@3x.png": "6189",
	"./PICertification/content_bg2@2x.png": "8858",
	"./PICertification/content_bg2@3x.png": "bbd3",
	"./PICertification/content_bg@2x.png": "6a2e",
	"./PICertification/content_bg@3x.png": "9d53",
	"./PICertification/del_country.png": "9651",
	"./PICertification/icon_PDF@3x.png": "852f",
	"./PICertification/icon_avatar@2x.png": "485b",
	"./PICertification/icon_avatar@3x.png": "01f7",
	"./PICertification/icon_avatar_bg@2x.png": "6f36",
	"./PICertification/icon_avatar_bg@3x.png": "00e0",
	"./PICertification/icon_close@2x.png": "7abd",
	"./PICertification/icon_close@3x.png": "4ec9",
	"./PICertification/icon_comma@2x.png": "4272",
	"./PICertification/icon_comma@3x.png": "6548",
	"./PICertification/icon_eye_open.png": "a0f9",
	"./PICertification/icon_eye_open@2x.png": "1a61",
	"./PICertification/icon_fail@2x.png": "8344",
	"./PICertification/icon_fail@3x.png": "5279",
	"./PICertification/icon_kefu@2x.png": "6a83",
	"./PICertification/icon_kefu@3x.png": "1584",
	"./PICertification/icon_logo_cn@2x.png": "ff9a",
	"./PICertification/icon_logo_cn@3x.png": "df28",
	"./PICertification/icon_logo_tc@2x.png": "9b08",
	"./PICertification/icon_logo_tc@3x.png": "19a1",
	"./PICertification/icon_number_0@2x.png": "370d",
	"./PICertification/icon_number_0@3x.png": "4c0b",
	"./PICertification/icon_number_8@2x.png": "8f515",
	"./PICertification/icon_number_8@3x.png": "343f",
	"./PICertification/icon_pending@2x.png": "5b09",
	"./PICertification/icon_pending@3x.png": "9ca0",
	"./PICertification/icon_plus@2x.png": "8851",
	"./PICertification/icon_plus@3x.png": "684a",
	"./PICertification/icon_sel@2x.png": "d813",
	"./PICertification/icon_sel@3x.png": "e360",
	"./PICertification/icon_setup_eye_select@2x.png": "2878",
	"./PICertification/icon_setup_eye_select@3x.png": "033f",
	"./PICertification/icon_setup_mianrong@2x.png": "3bd8",
	"./PICertification/icon_setup_mianrong@3x.png": "5e5c",
	"./PICertification/icon_success@2x.png": "931d",
	"./PICertification/icon_success@3x.png": "436e",
	"./PICertification/icon_text_left@2x.png": "1870",
	"./PICertification/icon_text_left@3x.png": "73a2",
	"./PICertification/icon_text_right@2x.png": "5e58",
	"./PICertification/icon_text_right@3x.png": "cf3b",
	"./PICertification/icon_tick@2x.png": "03fb",
	"./PICertification/icon_tick@3x.png": "b339",
	"./PICertification/icon_tips@2x.png": "08c7",
	"./PICertification/icon_tips@3x.png": "9d16",
	"./PICertification/icon_upload@2x.png": "85ef",
	"./PICertification/icon_upload@3x.png": "98b1",
	"./PICertification/icon_zhiwen@2x.png": "a222",
	"./PICertification/icon_zhiwen@3x.png": "7fce",
	"./PICertification/invest_arrow@2x.png": "b548",
	"./PICertification/invest_arrow@3x.png": "34e8",
	"./PICertification/love_invest_bg@2x.png": "1f31",
	"./PICertification/love_invest_bg@3x.png": "183d",
	"./PICertification/number_bg@2x.png": "f548",
	"./PICertification/number_bg@3x.png": "1d42",
	"./PICertification/pzlx1@3x.png": "a8db",
	"./PICertification/pzlx2@3x.png": "87dc",
	"./PICertification/pzlx3@3x.png": "c984",
	"./PICertification/pzlx4@3x.png": "caba",
	"./PICertification/pzlx5@3x.png": "662b",
	"./PICertification/reference.png": "2ead",
	"./PICertification/star_text_bg@2x.png": "761a",
	"./PICertification/star_text_bg@3x.png": "3a23",
	"./PICertification/upload_bg@2x.png": "a585",
	"./PICertification/upload_bg@3x.png": "7207",
	"./PICertification/vip_icon1@2x.png": "abe0",
	"./PICertification/vip_icon1@3x.png": "a98b",
	"./PICertification/vip_icon2@2x.png": "40f7",
	"./PICertification/vip_icon2@3x.png": "606c",
	"./PICertification/vip_icon3@2x.png": "ce47",
	"./PICertification/vip_icon3@3x.png": "3d32",
	"./PICertification/vip_icon4@2x.png": "5666",
	"./PICertification/vip_icon4@3x.png": "399c",
	"./THS_box/auotexc.png": "4693",
	"./THS_box/card.png": "398a",
	"./THS_box/gift.png": "9b9e",
	"./THS_box/icon_improve_info.png": "8565",
	"./THS_box/identifier.png": "0f3f",
	"./THS_box/more.png": "833d",
	"./THS_box/trade.png": "6f71",
	"./THS_box/userInfo.png": "d705",
	"./THS_box/xcm.png": "f827",
	"./accountAssets/icon-arrow-down@2x.png": "eec4",
	"./accountAssets/icon-arrow-down@3x.png": "f29c",
	"./accountAssets/icon_trade_eye_colse@2x.png": "ca20",
	"./accountAssets/icon_trade_eye_colse@3x.png": "bcb7",
	"./accountAssets/icon_trade_eye_normal@2x.png": "7d6e",
	"./accountAssets/icon_trade_eye_normal@3x.png": "8221",
	"./activityCard/activity-icon-2.png": "938e",
	"./activityCard/activity-icon.png": "f80b",
	"./activityCard/chat.png": "846a",
	"./activityCenter/arrow_left.png": "8977",
	"./activityCenter/empty.png": "d3be",
	"./activityCenter/empty02.png": "7415",
	"./activityCenter/exchange/banner2_cn.png": "58b3",
	"./activityCenter/exchange/banner2_tc.png": "b14d",
	"./activityCenter/exchange/banner_cn.png": "d80a",
	"./activityCenter/exchange/banner_tc.png": "31b1",
	"./activityCenter/gift-icon.png": "2438",
	"./annualStatement/arrow.png": "19e5",
	"./annualStatement/bg-0-pi.png": "4142",
	"./annualStatement/bg-0.png": "2add",
	"./annualStatement/bg-1.png": "6009",
	"./annualStatement/bg-2.png": "500c",
	"./annualStatement/bg-3.png": "7763",
	"./annualStatement/bg-4.png": "ecef",
	"./annualStatement/bg-5.png": "3c47",
	"./annualStatement/btn-pi.png": "1a64",
	"./annualStatement/home-logo-pi.png": "d615",
	"./annualStatement/home-logo-pi_tc.png": "98ab",
	"./annualStatement/home-logo.png": "0713",
	"./annualStatement/home-logo_tc.png": "e86e",
	"./annualStatement/img-0-pi.png": "821e",
	"./annualStatement/img-0.png": "3943",
	"./annualStatement/img-1.png": "8691",
	"./annualStatement/img-2-1.png": "adc0",
	"./annualStatement/img-2.png": "ad75",
	"./annualStatement/img-3.png": "6f46",
	"./annualStatement/img-4.png": "b2e5",
	"./annualStatement/img-5.png": "a6e4",
	"./annualStatement/img-6.png": "0da5",
	"./annualStatement/logo.png": "d886",
	"./annualStatement/result-bg.png": "e0a5",
	"./annualStatement/result-btn.png": "19ae",
	"./annualStatement/result-img.png": "dae7",
	"./annualStatement/save-o.png": "a0c3",
	"./annualStatement/save.png": "9824",
	"./annualStatement/share-o.png": "55d6",
	"./annualStatement/share.png": "89df",
	"./annualStatement/yun.png": "f35f",
	"./appAdvisor/32.png": "fdb5",
	"./appAdvisor/advisor-item-bg@2x.png": "c8fb",
	"./appAdvisor/advisor-item-bg@3x.png": "30d2",
	"./appAdvisor/avator_big.png": "1e8d",
	"./appAdvisor/avator_small.png": "f05a",
	"./appAdvisor/book.png": "6307",
	"./appAdvisor/book@2x.png": "dc4e",
	"./appAdvisor/book@3x.png": "6e1d",
	"./appAdvisor/circle@2x.png": "4baa",
	"./appAdvisor/circle@3x.png": "f846",
	"./appAdvisor/code-wrapper-bg-higher@2x.png": "62cc",
	"./appAdvisor/code-wrapper-bg@2x.png": "4dbe",
	"./appAdvisor/default-code.png": "a3ea",
	"./appAdvisor/huangguan@2x.png": "e46b",
	"./appAdvisor/huangguan@3x.png": "632c",
	"./appAdvisor/kefu@2x.png": "973c",
	"./appAdvisor/kefu@3x.png": "19a4",
	"./appAdvisor/question@2x.png": "11fd",
	"./appAdvisor/question@3x.png": "046b",
	"./appAdvisor/renzheng@2x.png": "8e42",
	"./appAdvisor/renzheng@3x.png": "c67f",
	"./appAdvisor/success.png": "669c",
	"./appAdvisor/tx.png": "bcfe",
	"./assetTransferAgreement/icon_kefu.png": "be683",
	"./assetTransferAgreement/icon_radius.png": "328b",
	"./assetTransferAgreement/pic.png": "ed2c",
	"./bankCard/amtw_bank.png": "a07e",
	"./bankCard/hk_bank.png": "d666",
	"./bankCard/other_bank.png": "fde23",
	"./bankCard/usa_bank.png": "7c28",
	"./benefitCards/fifth.png": "76c2",
	"./benefitCards/fifthGray.png": "dbdb",
	"./benefitCards/fouth.png": "fcc2",
	"./benefitCards/fouthGray.png": "41dc",
	"./benefitCards/one.png": "4432",
	"./benefitCards/oneGray.png": "05a2",
	"./benefitCards/oneGraypng.png": "417b",
	"./benefitCards/three.png": "c3e0",
	"./benefitCards/threeGray.png": "4126",
	"./benefitCards/two.png": "730f",
	"./benefitCards/twoGray.png": "68e0",
	"./bnyPage/bny-detail-1.png": "393d",
	"./bnyPage/bny-detail-2.png": "a66e",
	"./bnyPage/bny-detail-3.png": "87a2",
	"./bnyPage/bny-detail-4.png": "caa0",
	"./bnyPage/bny-detail-5.png": "9764",
	"./bnyPage/bny-detail-6.png": "a19f",
	"./bnyPage/bny-detail-7.png": "31a9",
	"./builderPage/header.png": "3170",
	"./builderPage/header_old.png": "2287",
	"./builderPage/nodata.png": "95b2",
	"./builderPage/nodata_black.png": "1054",
	"./cashBoxPromotion/img1zhCn.png": "f803",
	"./cashBoxPromotion/img1zhTc.png": "6f2e",
	"./cashBoxPromotion/img2zhCn.png": "54c6",
	"./cashBoxPromotion/img2zhTc.png": "9af3",
	"./cashBoxPromotion/img3zhCn.png": "1e8a",
	"./cashBoxPromotion/img3zhTc.png": "5cbf",
	"./cashBoxPromotion/img4zhCn.png": "9b4f",
	"./cashBoxPromotion/img4zhTc.png": "af41",
	"./cashBoxPromotion/img5zhCn.png": "8869",
	"./cashBoxPromotion/img5zhTc.png": "5ec7",
	"./cashBoxPromotion/img6.png": "1a6a",
	"./cashToMargin/CHN@2x.png": "98c3",
	"./cashToMargin/CHN@3x.png": "3578",
	"./cashToMargin/HK@2x.png": "44a9",
	"./cashToMargin/HK@3x.png": "9810",
	"./cashToMargin/US@2x.png": "474f",
	"./cashToMargin/US@3x.png": "7c39",
	"./cashToMargin/empty.png": "5ac7",
	"./cashToMargin/icon_kefu.png": "369e",
	"./cashToMargin/success.png": "4df1",
	"./cashToMargin/wait.png": "dfcd",
	"./cashToMargin/warn.png": "bda1",
	"./certifyZone/add_car_tc.png": "0a1f",
	"./certifyZone/add_car_zh.png": "a761",
	"./certifyZone/arrow_left.png": "c13d",
	"./certifyZone/equityIcon1.png": "f752",
	"./certifyZone/equityIcon2.png": "db7f",
	"./certifyZone/equityIcon3.png": "282a",
	"./certifyZone/equityIcon4.png": "bf0d",
	"./certifyZone/equityIcon5.png": "72a8",
	"./certifyZone/equityIcon6.png": "810b",
	"./certifyZone/head.png": "8006",
	"./certifyZone/home_bg_tc.png": "a279",
	"./certifyZone/home_bg_zh.png": "bfe9",
	"./certifyZone/owner-right.png": "43d8",
	"./certifyZone/pic_1_tc.png": "6713",
	"./certifyZone/pic_1_zh.png": "5f46",
	"./certifyZone/pic_2_tc.png": "ba3c",
	"./certifyZone/pic_2_zh.png": "ba13",
	"./certifyZone/pic_3_tc.png": "7aa3",
	"./certifyZone/pic_3_zh.png": "a6cb",
	"./certifyZone/qrcode.png": "c2ea",
	"./certifyZone/t-left.png": "6c50",
	"./certifyZone/t-right.png": "66be",
	"./certifyZone/tmt-right.png": "45ca",
	"./certifyZone/used.png": "b41f",
	"./certifyZone/userEquity1.png": "aa7b",
	"./certifyZone/userEquity2.png": "61cb",
	"./certifyZone/userEquity3.png": "d36b",
	"./certifyZone/userEquity4.png": "1497",
	"./certifyZone/userEquity5.png": "5d46",
	"./certifyZone/userEquity6.png": "28ab",
	"./certifyZone/userEquity7.png": "69f7",
	"./certifyZone/user_bg.png": "a3f7",
	"./certifyZone/vip-y.png": "9495",
	"./certifyZone/vip.png": "6ef7",
	"./changeEmail/clear@2x.png": "7dea",
	"./changeEmail/clear@3x.png": "5f14",
	"./changeEmail/info20@2x.png": "fbb7",
	"./changeEmail/info20@3x.png": "5d66",
	"./changeEmail/info@2x.png": "a260",
	"./changeEmail/info@3x.png": "f23d",
	"./changeEmail/set_email@2x.png": "3fa0",
	"./changeEmail/set_email@3x.png": "0b54",
	"./changeEmail/success@2x.png": "7ca9",
	"./changeEmail/success@3x.png": "b260",
	"./changePhone/clear@2x.png": "3085",
	"./changePhone/clear@3x.png": "c658",
	"./changePhone/info20@2x.png": "1bfe",
	"./changePhone/info20@3x.png": "4964",
	"./changePhone/info@2x.png": "53ce",
	"./changePhone/info@3x.png": "8340",
	"./changePhone/set_phone@2x.png": "51bd",
	"./changePhone/set_phone@3x.png": "e2fc",
	"./changePhone/success@2x.png": "df86",
	"./changePhone/success@3x.png": "26e7a",
	"./common/12_icon_right_arrow_line@2x.png": "2295",
	"./common/12_icon_right_arrow_line@3x.png": "59fc",
	"./common/avatar.png": "bb70",
	"./common/avatar_sm.png": "f73e",
	"./common/close.png": "8eeb",
	"./common/closePopup.png": "19e3",
	"./common/fosun-logo-text@2x.png": "46b7",
	"./common/fosun-logo-text@3x.png": "c34c",
	"./common/hk-icon-black.png": "ec3a",
	"./common/hk-icon.png": "bd05",
	"./common/icon-arrow-below-20@2x.png": "6579",
	"./common/icon-arrow-below-20@3x.png": "31b0",
	"./common/icon-arrow-up-20@2x.png": "dacf",
	"./common/icon-arrow-up-20@3x.png": "d799",
	"./common/icon-search@2x.png": "4755",
	"./common/icon-search@3x.png": "a606",
	"./common/icon_arrow_down@2x.png": "2fbe",
	"./common/icon_arrow_down@3x.png": "b2d6",
	"./common/icon_arrow_left_12@2x.png": "1bf05",
	"./common/icon_arrow_left_12@3x.png": "ed1f",
	"./common/icon_arrow_right.png": "c2bc",
	"./common/icon_expect@2x.png": "211c",
	"./common/icon_expect@3x.png": "4570",
	"./common/icon_pdf_statement@2x.png": "834a",
	"./common/icon_pdf_statement@3x.png": "13ac",
	"./common/icon_popup_close@3x.png": "c707",
	"./common/icon_service@2x.png": "33dd",
	"./common/icon_service@3x.png": "d2cb",
	"./common/icon_status@2x.png": "3e96",
	"./common/icon_status@3x.png": "9024",
	"./common/icon_success@2x.png": "9b42",
	"./common/icon_success@3x.png": "79db",
	"./common/icon_tips@2x.png": "2155",
	"./common/icon_tips@3x.png": "900d",
	"./common/icon_warn@2x.png": "897c",
	"./common/icon_warn@3x.png": "b75e",
	"./common/img_default_empty@2x.png": "ce36",
	"./common/img_default_empty@3x.png": "6aa2",
	"./common/img_search_empty@2x.png": "4f2c",
	"./common/img_search_empty@3x.png": "58d9",
	"./common/loading.png": "3686",
	"./common/logo-1-black.png": "aac4",
	"./common/logo1.png": "73a5",
	"./common/logo@3x.png": "f0d1",
	"./common/logo_text.png": "e56b",
	"./common/market/HK.png": "e9c5",
	"./common/market/SH.png": "93c0",
	"./common/market/SZ.png": "c10f",
	"./common/market/US.png": "986a",
	"./common/market/hk-bg.png": "020d",
	"./common/market/us-bg.png": "f8bf",
	"./common/more-new.png": "01c2",
	"./common/onlineService-black.png": "1392",
	"./common/onlineService.png": "3c430",
	"./common/phone-icon-black.png": "911a",
	"./common/phone-icon.png": "7cb1",
	"./common/serve-icon.png": "bd9a",
	"./common/tip-icon.png": "3793",
	"./common/white_arrow.png": "65f0",
	"./components/ad_placeholder@2x.png": "f28e",
	"./components/ad_placeholder@3x.png": "1b03",
	"./cooperationLandingPage/button@2x.png": "f9ea",
	"./cooperationLandingPage/button_one.png": "c442",
	"./cooperationLandingPage/icon_check.png": "262c",
	"./cooperationLandingPage/icon_city.png": "4232",
	"./cooperationLandingPage/icon_equity.png": "74d1",
	"./cooperationLandingPage/icon_name.png": "7c77",
	"./cooperationLandingPage/icon_phone.png": "296c",
	"./cooperationLandingPage/kefu.png": "b35d",
	"./cooperationLandingPage/sj.png": "9224",
	"./corCertify/btn.png": "900e",
	"./corCertify/dropdown.png": "4095",
	"./corCertify/head.png": "ef85",
	"./corCertify/invite.png": "2115",
	"./corCertify/logo.png": "f73e2",
	"./corCertify/nodata.png": "316c",
	"./corCertify/pic_1_tc.png": "6157",
	"./corCertify/pic_1_tc_new.png": "b230",
	"./corCertify/pic_1_zh.png": "a1f1",
	"./corCertify/pic_1_zh_new.png": "8f93",
	"./corCertify/pic_2_tc.png": "54ef",
	"./corCertify/pic_2_tc_new.png": "e8b70",
	"./corCertify/pic_2_zh.png": "703d",
	"./corCertify/pic_2_zh_new.png": "bec2",
	"./corCertify/pic_3_tc.png": "d7f7",
	"./corCertify/pic_3_tc_new.png": "3ecd",
	"./corCertify/pic_3_zh.png": "0a7e",
	"./corCertify/pic_3_zh_new.png": "bc14",
	"./corCertify/pic_4_tc.png": "35f6",
	"./corCertify/pic_4_zh.png": "c5ef",
	"./corCertify/pic_5_tc.png": "7dc1",
	"./corCertify/pic_5_zh.png": "ecda",
	"./corCertify/right_tc.png": "c30a",
	"./corCertify/right_tc_new.png": "b0a95",
	"./corCertify/right_zh.png": "6ee7",
	"./corCertify/right_zh_new.png": "3511",
	"./corCertify/success.png": "4a73",
	"./corCertify/user_bg.png": "65a5",
	"./corCertify/user_bg_tc.png": "a5e5",
	"./corCertify/user_bg_zh.png": "f11a",
	"./corCertify/user_card_bg.png": "8595",
	"./corCertify/vip.png": "30f3",
	"./corpW8/notSigned.png": "2d30",
	"./corpW8/signed.png": "b047",
	"./corpW8/success.png": "671a",
	"./corpW8/tip.png": "20b1",
	"./corporateActions/icon_add@2x.png": "39f4",
	"./corporateActions/icon_add@3x.png": "df95",
	"./corporateActions/icon_radio@2x.png": "aeaf",
	"./corporateActions/icon_radio@3x.png": "6e45",
	"./corporateActions/icon_radio_checked@2x.png": "8a1c",
	"./corporateActions/icon_radio_checked@3x.png": "2df7",
	"./corporateActions/icon_sub@2x.png": "68f7",
	"./corporateActions/icon_sub@3x.png": "b069",
	"./corporateActions/icon_success@2x.png": "e148",
	"./corporateActions/icon_success@3x.png": "0d18",
	"./corporateActions/icon_tips@2x.png": "457d",
	"./corporateActions/icon_tips@3x.png": "0c89",
	"./corporateActions/icon_waiting@2x.png": "d7ac",
	"./corporateActions/icon_waiting@3x.png": "905c",
	"./corporateActions/noHistory@2x.png": "005a",
	"./corporateActions/noHistory@3x.png": "bea3",
	"./corporateActions/nodata@2x.png": "694a",
	"./corporateActions/nodata@3x.png": "525b",
	"./faWealthInformationDetail/noData.png": "4ac9",
	"./financialAccount/user@2x.png": "ade9",
	"./financialAccount/user@3x.png": "0148",
	"./finfo/logo@2x.png": "6876",
	"./finfo/logo@3x.png": "101c",
	"./followUp/about_zhCn.png": "c0fb",
	"./followUp/about_zhTc.png": "d2a9",
	"./followUp/bk.png": "e435",
	"./followUp/btimg.png": "441b",
	"./followUp/coupon_zhCn.png": "cee0",
	"./followUp/coupon_zhTc.png": "8b55",
	"./followUp/gtzy1_zhCn.png": "8f72",
	"./followUp/gtzy1_zhTc.png": "4a57",
	"./followUp/icon_close.png": "2941",
	"./followUp/iconleft.png": "e560",
	"./followUp/iconright.png": "5333",
	"./followUp/jt.png": "cd68",
	"./followUp/ljdk_zhCn.png": "134a",
	"./followUp/ljdk_zhTc.png": "368b",
	"./followUp/rulebg.png": "7d24",
	"./followUp/tzzh_zhCn.png": "a7ab",
	"./followUp/tzzh_zhTc.png": "64ef",
	"./followUp/ylq_zhCn.png": "4c74",
	"./followUp/ylq_zhTc.png": "54f1",
	"./followUp/zhys_zhCn.png": "1cc4",
	"./followUp/zhys_zhTc.png": "c48b",
	"./followUp/zwdk.png": "f59e",
	"./followUpHK/about_zhCn.png": "cdb0",
	"./followUpHK/about_zhTc-.png": "49cb",
	"./followUpHK/about_zhTc.png": "7738e",
	"./followUpHK/bk.png": "b7e4",
	"./followUpHK/btimg.png": "66bd",
	"./followUpHK/coupon_zhCn.png": "a7bb",
	"./followUpHK/coupon_zhTc.png": "f335",
	"./followUpHK/gtzy1_zhCn-.png": "2d5c",
	"./followUpHK/gtzy1_zhTc-.png": "8375",
	"./followUpHK/gtzy1_zhTc.png": "0acb",
	"./followUpHK/icon_close.png": "8ded",
	"./followUpHK/iconleft.png": "69f8",
	"./followUpHK/iconright.png": "7819",
	"./followUpHK/jt.png": "676b",
	"./followUpHK/ljdk_zhCn.png": "7934",
	"./followUpHK/ljdk_zhTc.png": "8124",
	"./followUpHK/lqct.png": "5c6c",
	"./followUpHK/rulebg.png": "9b48",
	"./followUpHK/tzzh_zhCn.png": "3dd9",
	"./followUpHK/tzzh_zhTc-.png": "9b78",
	"./followUpHK/tzzh_zhTc.png": "4382",
	"./followUpHK/ylq_zhCn.png": "b512",
	"./followUpHK/ylq_zhTc.png": "639c",
	"./followUpHK/zhys_zhCn.png": "a3e0",
	"./followUpHK/zhys_zhTc-.png": "20ae",
	"./followUpHK/zhys_zhTc.png": "8df1",
	"./followUpHK/zwdk.png": "82b3",
	"./followUpMay/about_zhCn.png": "2727",
	"./followUpMay/about_zhTc.png": "9f31",
	"./followUpMay/bk.png": "bdea",
	"./followUpMay/btimg.png": "98c3c",
	"./followUpMay/coupon_zhCn.png": "e0d2",
	"./followUpMay/coupon_zhTc.png": "7a78",
	"./followUpMay/gtzy1_zhCn.png": "4052",
	"./followUpMay/gtzy1_zhTc.png": "1841",
	"./followUpMay/icon_close.png": "80b8",
	"./followUpMay/iconleft.png": "a8e9",
	"./followUpMay/iconright.png": "5e1d",
	"./followUpMay/jt.png": "6326",
	"./followUpMay/ljdk_zhCn.png": "cbf3",
	"./followUpMay/ljdk_zhTc.png": "7324",
	"./followUpMay/rulebg.png": "3768",
	"./followUpMay/tzzh_zhCn.png": "13bd",
	"./followUpMay/tzzh_zhTc.png": "551b",
	"./followUpMay/ylq_zhCn.png": "08ad",
	"./followUpMay/ylq_zhTc.png": "2aeaa",
	"./followUpMay/zhys_zhCn.png": "e289",
	"./followUpMay/zhys_zhTc.png": "0090",
	"./followUpMay/zwdk.png": "b1f7",
	"./fundAccount/CH_Phone.png": "8a73",
	"./fundAccount/HK_Phone.png": "357e",
	"./fundAccount/Union.png": "05de",
	"./fundAccount/WX_Service.png": "3f95",
	"./fundAccount/WeCom.png": "0cd0",
	"./fundAccount/closePopup.png": "c844",
	"./fundAccount/icon_kefu.png": "2095",
	"./fundAccount/user@2x.png": "93b6",
	"./fundAccount/user@3x.png": "0d9e",
	"./hlvip/btn_bg.png": "ae13",
	"./hlvip/card_bg.png": "fe9c",
	"./hlvip/card_bj@2x.png": "ee81",
	"./hlvip/card_bj@3x.png": "0bfb",
	"./hlvip/card_diamond@2x.png": "bc7d",
	"./hlvip/card_diamond@3x.png": "6bfa",
	"./hlvip/card_hj@2x.png": "ce76",
	"./hlvip/card_hj@3x.png": "f7c6",
	"./hlvip/diamong_tctext.png": "3ea5",
	"./hlvip/diamong_text.png": "2784",
	"./hlvip/down.png": "fbdd",
	"./hlvip/expect.png": "99b2",
	"./hlvip/lefticon.png": "9e89",
	"./hlvip/mask.png": "7b3a",
	"./hlvip/privilege1.png": "8551",
	"./hlvip/privilege10.png": "085e",
	"./hlvip/privilege11.png": "d274",
	"./hlvip/privilege12.png": "ced2",
	"./hlvip/privilege13.png": "ea9c",
	"./hlvip/privilege14.png": "10c1",
	"./hlvip/privilege15.png": "cb03",
	"./hlvip/privilege2.png": "0581",
	"./hlvip/privilege3.png": "cbfe",
	"./hlvip/privilege4.png": "d443",
	"./hlvip/privilege5.png": "795c",
	"./hlvip/privilege6.png": "1aa0",
	"./hlvip/privilege7.png": "f48b",
	"./hlvip/privilege8.png": "43b7",
	"./hlvip/privilege9.png": "e158",
	"./hlvip/privilegeleft.png": "34ec",
	"./hlvip/privilegeright.png": "dc2d",
	"./hlvip/qrcode.png": "f315",
	"./hlvip/righticon.png": "3f4f",
	"./hlvip/tc/expect.png": "ba78",
	"./hlvip/tc/privilege1.png": "2108",
	"./hlvip/tc/privilege10.png": "6c4c",
	"./hlvip/tc/privilege11.png": "d77e",
	"./hlvip/tc/privilege12.png": "f1cb",
	"./hlvip/tc/privilege13.png": "6cab",
	"./hlvip/tc/privilege14.png": "1695",
	"./hlvip/tc/privilege15.png": "7836",
	"./hlvip/tc/privilege2.png": "54a9",
	"./hlvip/tc/privilege3.png": "a432",
	"./hlvip/tc/privilege4.png": "c105",
	"./hlvip/tc/privilege5.png": "fdcf",
	"./hlvip/tc/privilege6.png": "515f",
	"./hlvip/tc/privilege7.png": "cbd7",
	"./hlvip/tc/privilege8.png": "57b7",
	"./hlvip/tc/privilege9.png": "48e3",
	"./hlvip/up.png": "59ba",
	"./hlvip/v1.png": "775f6",
	"./hlvip/v2.png": "2675",
	"./hlvip/v3.png": "6f7a",
	"./identifierGuide/success.png": "cb57",
	"./information/icon_love.png": "5fbc",
	"./information/icon_love_active.png": "1a86",
	"./information/icon_love_black.png": "4d92",
	"./initTradePassword/icon_i_common.png": "3604",
	"./initTradePassword/icon_password_eye_colse.png": "641c",
	"./initTradePassword/icon_password_eye_open.png": "ecbc",
	"./initTradePassword/icon_search_dell.png": "b43b",
	"./initTradePassword/tip@2x.png": "44de",
	"./initTradePassword/tip@3x.png": "ed93",
	"./ipoRation/b-next.png": "99fb",
	"./ipoRation/icon_i.png": "1fe0",
	"./ipoRation/o-next.png": "a03e",
	"./ipoRation/step1-t.png": "6b6a",
	"./ipoRation/step1.png": "174f",
	"./ipoRation/step2-d.png": "1711",
	"./ipoRation/step2-t.png": "0f34",
	"./ipoRation/step2.png": "6e9e",
	"./ipoRation/step3-d.png": "d12e",
	"./ipoRation/step3-t.png": "1767",
	"./ipoRation/step3.png": "e2da",
	"./ipoRation/step4-d.png": "64c0",
	"./ipoRation/step4-t.png": "2dc8",
	"./knowledgeQuestionnaire/bg-dialog@3x.png": "8ca8",
	"./knowledgeQuestionnaire/icon-error@2x.png": "0368",
	"./knowledgeQuestionnaire/icon-error@3x.png": "baa1",
	"./knowledgeQuestionnaire/icon-right@2x.png": "4e74",
	"./knowledgeQuestionnaire/icon-right@3x.png": "5d14",
	"./login/addContact.png": "0eaf",
	"./login/agree.png": "79c4",
	"./login/bg@2x.png": "ea68",
	"./login/bg@3x.png": "2f50",
	"./login/close.png": "147e",
	"./login/icon_copy.png": "e80b",
	"./login/idCard.png": "6612",
	"./login/img_invite_friends_header.png": "594b",
	"./login/logo@2x.png": "3de1",
	"./login/logo@3x.png": "ea97",
	"./login/note.png": "7abc",
	"./login/oval.png": "4ebe",
	"./login/question.png": "213d",
	"./login/sj.png": "75d1",
	"./login/toggle_down.png": "477d",
	"./login/toggle_up.png": "54e2",
	"./logo.png": "9d64",
	"./message/active.png": "7abb",
	"./message/active_black.png": "99b0",
	"./message/clean.png": "a49f",
	"./message/clean_black.png": "3505",
	"./message/close.png": "3c8c",
	"./message/empty.png": "4235",
	"./message/empty_black.png": "c8d2",
	"./message/msg.png": "9e6d",
	"./message/msg_black.png": "cc4f",
	"./message/next.png": "1799",
	"./message/notion.png": "3a9b",
	"./message/notion_black.png": "a2af",
	"./message/real-time.png": "085a",
	"./message/realTime.png": "a9ea",
	"./message/realTime_black.png": "5b1b",
	"./message/service.png": "8d7c",
	"./message/service_black.png": "ed62",
	"./message/start.png": "2867",
	"./message/subscribeRemind.png": "a9e4",
	"./message/subscribeRemind_black.png": "0d57",
	"./message/trade.png": "5116",
	"./message/trade_black.png": "1f5b",
	"./middlePage/close.png": "41da",
	"./middlePage/logo.png": "6083",
	"./middlePage/logo@2x.png": "0783",
	"./middlePage/logo@3x.png": "364e",
	"./middlePage/sj.png": "141b",
	"./morningPaper/1.png": "fd08",
	"./morningPaper/10.png": "abf5",
	"./morningPaper/2.png": "0326",
	"./morningPaper/3.png": "4a9a",
	"./morningPaper/3words_title.png": "2a73",
	"./morningPaper/3words_title@2x.png": "e737",
	"./morningPaper/4.png": "00e02",
	"./morningPaper/4words_title.png": "852c",
	"./morningPaper/4words_title@2x.png": "4127",
	"./morningPaper/5.png": "a84f",
	"./morningPaper/6.png": "77aa",
	"./morningPaper/7.png": "ea55",
	"./morningPaper/8.png": "dd2a",
	"./morningPaper/9.png": "2c89",
	"./morningPaper/Groupleft.png": "b667",
	"./morningPaper/Groupright.png": "a756",
	"./morningPaper/bg-1.png": "a8b6",
	"./morningPaper/bg-2.png": "3f89",
	"./morningPaper/copy.png": "5273",
	"./morningPaper/dot.png": "2f30",
	"./morningPaper/dot@2x.png": "dddb",
	"./morningPaper/header_bg.png": "78aa",
	"./morningPaper/header_bg@2x.png": "d904",
	"./morningPaper/header_bg_tc.png": "4848",
	"./morningPaper/header_bg_tc@2x.png": "855f",
	"./morningPaper/icon-bf.png": "2102",
	"./morningPaper/icon-zt.png": "fd85",
	"./morningPaper/icon-zzd.png": "b8ee",
	"./morningPaper/time_frame.png": "4221",
	"./morningPaper/time_frame@2x.png": "8e27",
	"./mycharge/chosen-icon.png": "a229",
	"./mycharge/success-status.png": "a1a3",
	"./mycharge/todown.png": "8caf",
	"./mycharge/toup.png": "d771",
	"./mycharge/zhang-ing.png": "6245",
	"./mycharge/zhang-success.png": "b501",
	"./newPersonActivity/2024-10/button.png": "e87c",
	"./newPersonActivity/2024-10/first_zhCn.png": "c34b",
	"./newPersonActivity/2024-10/second_zhCn.png": "82d5",
	"./newPersonActivity/2024-10/third_zhCn.png": "661c",
	"./newPersonActivity/2025-7/about-fosun-zhCn.png": "3910",
	"./newPersonActivity/2025-7/about-fosun-zhTc.png": "e2db",
	"./newPersonActivity/2025-7/awards-zhCn.png": "a324",
	"./newPersonActivity/2025-7/awards-zhTc.png": "b97f",
	"./newPersonActivity/2025-7/btn-bg.png": "b320",
	"./newPersonActivity/2025-7/btn-disabled.png": "ab08",
	"./newPersonActivity/2025-7/close.png": "4630",
	"./newPersonActivity/2025-7/data-zhCn.png": "051a",
	"./newPersonActivity/2025-7/data-zhTc.png": "87d9",
	"./newPersonActivity/2025-7/disclaimer-zhCn.png": "d67c",
	"./newPersonActivity/2025-7/disclaimer-zhTc.png": "50fc",
	"./newPersonActivity/2025-7/fireworks-animation.png": "e51a",
	"./newPersonActivity/2025-7/gift-dialog.png": "a0c7",
	"./newPersonActivity/2025-7/header-bg-zhCn.png": "274e",
	"./newPersonActivity/2025-7/header-bg-zhTc.png": "87f3",
	"./newPersonActivity/December/button.png": "6ab1",
	"./newPersonActivity/December/first_zhCn.png": "dfee",
	"./newPersonActivity/December/first_zhTc.png": "255b",
	"./newPersonActivity/December/five_zhCn.png": "da2d",
	"./newPersonActivity/December/five_zhTc.png": "0bab",
	"./newPersonActivity/December/four_zhCn.png": "7b34f",
	"./newPersonActivity/December/four_zhTc.png": "664c",
	"./newPersonActivity/December/pop_zhCn.png": "35fcf",
	"./newPersonActivity/December/pop_zhTc.png": "3123",
	"./newPersonActivity/December/second_zhCn.png": "84dd",
	"./newPersonActivity/December/second_zhTc.png": "29af",
	"./newPersonActivity/December/seven_zhCn.png": "0ff5",
	"./newPersonActivity/December/seven_zhTc.png": "4d1f",
	"./newPersonActivity/December/six_zhCn.png": "915b",
	"./newPersonActivity/December/six_zhTc.png": "056c",
	"./newPersonActivity/December/third_zhCn.png": "cfc4",
	"./newPersonActivity/December/third_zhTc.png": "9e4d8",
	"./newPersonActivity/March/first_zhCn.png": "661b",
	"./newPersonActivity/March/first_zhTc.png": "2f6d",
	"./newPersonActivity/March/second_zhCn.png": "41d1",
	"./newPersonActivity/March/second_zhCn_new.png": "d63b1",
	"./newPersonActivity/March/second_zhTc.png": "df92",
	"./newPersonActivity/March/second_zhTc_new.png": "9193",
	"./newPersonActivity/March/third_zhCn.png": "0111",
	"./newPersonActivity/March/third_zhTc.png": "216d",
	"./newPersonActivity/blindbox/bottom.png": "1b6e",
	"./newPersonActivity/blindbox/btn.png": "feaa",
	"./newPersonActivity/blindbox/gift1.png": "8254",
	"./newPersonActivity/blindbox/gift2.png": "59e1",
	"./newPersonActivity/blindbox/gift3.png": "6053",
	"./newPersonActivity/blindbox/gift4.png": "ad81",
	"./newPersonActivity/blindbox/gift5.png": "f3a4",
	"./newPersonActivity/blindbox/middle.png": "689a",
	"./newPersonActivity/blindbox/no_prize.png": "3dbe",
	"./newPersonActivity/blindbox/prize1.png": "9746",
	"./newPersonActivity/blindbox/prize2.png": "0351",
	"./newPersonActivity/blindbox/prize3.png": "7898",
	"./newPersonActivity/blindbox/prize4.png": "a099",
	"./newPersonActivity/blindbox/prize5.png": "d5e5",
	"./newPersonActivity/blindbox/prizeBtn.png": "137f",
	"./newPersonActivity/blindbox/prizeTitle.png": "3283",
	"./newPersonActivity/blindbox/prize_bg.png": "1f6b",
	"./newPersonActivity/blindbox/prize_head.png": "cd09",
	"./newPersonActivity/blindbox/top.png": "079a",
	"./newPersonActivity/bottom.png": "7c71",
	"./newPersonActivity/bottom2.png": "3e6f",
	"./newPersonActivity/bottom_hk.png": "afb8",
	"./newPersonActivity/bottom_hk2.png": "fcbb",
	"./newPersonActivity/bottomold.png": "6799",
	"./newPersonActivity/bottomold2.png": "7fa4",
	"./newPersonActivity/card.png": "148d",
	"./newPersonActivity/loading.png": "a1d1",
	"./newPersonActivity/loading2.png": "bcbf",
	"./newPersonActivity/middle.png": "a680",
	"./newPersonActivity/middle2.png": "c29f",
	"./newPersonActivity/moon/bottom.png": "20ec",
	"./newPersonActivity/moon/middle.png": "4e76",
	"./newPersonActivity/moon/top.png": "8435",
	"./newPersonActivity/pop.png": "3723",
	"./newPersonActivity/pop2.png": "1d02",
	"./newPersonActivity/rollOver/code@2x.png": "7017",
	"./newPersonActivity/rollOver/code@3x.png": "a0cb",
	"./newPersonActivity/rollOver/zhCn/1.png": "4cbd",
	"./newPersonActivity/rollOver/zhCn/2.png": "4826",
	"./newPersonActivity/rollOver/zhCn/3.png": "1a70",
	"./newPersonActivity/rollOver/zhCn/4.png": "672a",
	"./newPersonActivity/rollOver/zhCn/按钮.png": "7bf9",
	"./newPersonActivity/rollOver/zhTc/1.png": "a290",
	"./newPersonActivity/rollOver/zhTc/2.png": "be68",
	"./newPersonActivity/rollOver/zhTc/3.png": "898e",
	"./newPersonActivity/rollOver/zhTc/4.png": "083e",
	"./newPersonActivity/rollOver/zhTc/按钮.png": "d95a",
	"./newPersonActivity/top.png": "dd841",
	"./newPersonActivity/top2.png": "0718",
	"./newPersonActivity/top_hk.png": "9e76",
	"./newPersonActivity/top_hk2.png": "9187",
	"./newPersonActivity/topold.png": "0eb9",
	"./newPersonActivity/topold2.png": "f4a0",
	"./newPersonActivity/wealthbottom.png": "f62d",
	"./newPersonActivity/wealthbottom2.png": "644f",
	"./newPersonActivity/wealthfooter.png": "c501",
	"./newPersonActivity/wealthfooter2.png": "a729",
	"./newPersonActivity/wealthmiddle.png": "b1aa",
	"./newPersonActivity/wealthmiddle2.png": "897b",
	"./newPersonActivity/wealthtop.png": "3eda",
	"./newPersonActivity/wealthtop2.png": "6b21",
	"./newPersonActivity/xingcaibao/button.png": "6b8b",
	"./newPersonActivity/xingcaibao/zhCn/01.png": "33c8",
	"./newPersonActivity/xingcaibao/zhCn/02.png": "850e",
	"./newPersonActivity/xingcaibao/zhCn/03.png": "1de0",
	"./newPersonActivity/xingcaibao/zhCn/04.png": "1bc4",
	"./newPersonActivity/xingcaibao/zhCn/05.png": "4418",
	"./newPersonActivity/xingcaibao/zhTc/01.png": "7370",
	"./newPersonActivity/xingcaibao/zhTc/02.png": "2a12",
	"./newPersonActivity/xingcaibao/zhTc/03.png": "a42e",
	"./newPersonActivity/xingcaibao/zhTc/04.png": "556a",
	"./newPersonActivity/xingcaibao/zhTc/05.png": "9171",
	"./openAccount/90.png": "542d",
	"./openAccount/90p.png": "464e",
	"./openAccount/accoun-type/icon_chn.png": "0685",
	"./openAccount/accoun-type/icon_hk.png": "22f7",
	"./openAccount/accoun-type/icon_option.png": "08b8",
	"./openAccount/accoun-type/icon_us.png": "97f9",
	"./openAccount/accoun-type/icon_wealth.png": "2e35",
	"./openAccount/accoun-type/picker_sel.png": "1a4f",
	"./openAccount/add-image-1.png": "ea61",
	"./openAccount/add-image.png": "1301",
	"./openAccount/arrow-right.png": "ec59",
	"./openAccount/ca/ca_success.png": "7292",
	"./openAccount/ca/ca_success1.png": "948e",
	"./openAccount/check.png": "6801",
	"./openAccount/circular-circle-radio.png": "762a",
	"./openAccount/home/cn-ico.png": "9ee7",
	"./openAccount/home/hk-ico.png": "9920",
	"./openAccount/home/hk_1.png": "61ae",
	"./openAccount/home/hk_2.png": "531d",
	"./openAccount/home/hk_3.png": "3431",
	"./openAccount/home/icon_change.png": "c157",
	"./openAccount/home/n1.png": "22a2",
	"./openAccount/home/n2.png": "bf4d",
	"./openAccount/home/n3.png": "a68a",
	"./openAccount/icon_line_list.png": "7674",
	"./openAccount/icon_popup_close.png": "fc27",
	"./openAccount/icon_recommend.png": "e404",
	"./openAccount/id-card/check.png": "efd8",
	"./openAccount/id-card/error.png": "78e7",
	"./openAccount/id-card/hk_address-1.png": "b68a",
	"./openAccount/id-card/hk_address.png": "27e8",
	"./openAccount/id-card/hk_idCard-1.png": "6f6e",
	"./openAccount/id-card/hk_idCard.png": "6274",
	"./openAccount/id-card/mo-fm-1.png": "4f5d",
	"./openAccount/id-card/mo-fm.png": "2ab4",
	"./openAccount/id-card/mo-zm-1.png": "c7b0",
	"./openAccount/id-card/mo-zm.png": "2640",
	"./openAccount/id-card/pic_bank.png": "3c31",
	"./openAccount/id-card/pic_反光.png": "f7f8",
	"./openAccount/id-card/pic_标准.png": "591c",
	"./openAccount/id-card/pic_模糊.png": "5788",
	"./openAccount/id-card/pic_缺失.png": "bb7c",
	"./openAccount/id-card/re_file_up.png": "eb0d",
	"./openAccount/id-card/re_file_up_1.png": "77d7",
	"./openAccount/id-card/up_f-1.png": "5741",
	"./openAccount/id-card/up_f.png": "1193",
	"./openAccount/id-card/up_z-1.png": "2aea",
	"./openAccount/id-card/up_z.png": "4336",
	"./openAccount/image 12.png": "d0a2",
	"./openAccount/img_statement_clearance_receipt.png": "3a7b",
	"./openAccount/img_statement_template.png": "55c9",
	"./openAccount/living/livingWitness_camera-1.png": "1ff5",
	"./openAccount/living/livingWitness_camera.png": "8d46",
	"./openAccount/living/livingWitness_portrait.png": "526b",
	"./openAccount/loading-user.png": "4398",
	"./openAccount/loading.png": "2d83",
	"./openAccount/mr-status.png": "c586",
	"./openAccount/open-status/call_service.png": "b0c8",
	"./openAccount/open-status/call_service_black.png": "e9d4",
	"./openAccount/open-status/icon_kefu-n1.png": "09b6",
	"./openAccount/open-status/icon_kefu.png": "287c",
	"./openAccount/open-status/icon_kefu_black-1.png": "913e",
	"./openAccount/open-status/icon_kefu_black-n1.png": "1a23",
	"./openAccount/open-status/icon_kefu_black.png": "3468",
	"./openAccount/open-status/status_approving-01.png": "4b68",
	"./openAccount/open-status/status_approving.png": "3308",
	"./openAccount/open-status/status_approving_black-01.png": "b911",
	"./openAccount/open-status/status_approving_black.png": "0e02",
	"./openAccount/open-status/status_failed-01.png": "960a",
	"./openAccount/open-status/status_failed.png": "8cd4",
	"./openAccount/open-status/status_failed_black-01.png": "9b5a",
	"./openAccount/open-status/status_failed_black.png": "0d0d",
	"./openAccount/open-status/status_service.png": "785d",
	"./openAccount/open-status/status_success.png": "584f",
	"./openAccount/open-status/status_success_01.png": "382c",
	"./openAccount/open-status/status_success_black-01.png": "85a2",
	"./openAccount/open-status/status_success_black-1.png": "d4ef",
	"./openAccount/open-status/status_success_black.png": "e591",
	"./openAccount/popup-close.png": "f688",
	"./openAccount/prompt.png": "b068",
	"./openAccount/radio_checked.png": "5ed9",
	"./openAccount/risk/icon_card_play.png": "4dfa",
	"./openAccount/risk/icon_card_suspend.png": "2065",
	"./openAccount/search-no-data.png": "2bf5",
	"./openAccount/search.png": "908b",
	"./openAccount/square_check.png": "dfe2",
	"./openAccount/square_checked.png": "40db",
	"./openAccount/tax-info/search.png": "73ca",
	"./openAccount/template.png": "80d6",
	"./openAccount/tips.png": "9ec3",
	"./openAccount/toast-success.png": "6e9f",
	"./openAccount/w-8-add.png": "30e32",
	"./openAccountDCB/status.png": "7f64",
	"./optionsBonusActivity/Union.png": "2556",
	"./optionsBonusActivity/head.png": "7ab2",
	"./optionsBonusActivity/quan-bg.png": "5556",
	"./optionsUnusualActivity/emptyImg.png": "c604",
	"./optionsUnusualActivity/icon-search.png": "b108",
	"./purchasing/arrow_right.png": "cbb3",
	"./purchasing/icon_goumaili_cunru.png": "8923",
	"./purchasing/icon_goumaili_duihuan.png": "6e6c",
	"./purchasing/icon_goumaili_fundAllocation.png": "69a9",
	"./purchasing/icon_goumaili_qiandai.png": "5841",
	"./purchasing/icon_toast_success.png": "2af0",
	"./purchasing/status_finished.png": "29e7",
	"./purchasing/status_reject.png": "0ef0",
	"./purchasing/status_success.png": "1c38",
	"./purchasing/success.png": "8445",
	"./quotation/arrow_down.png": "9c29",
	"./quotation/arrow_up.png": "332c",
	"./quotation/checked@2x.png": "0e2b",
	"./quotation/checked@3x.png": "1e6b",
	"./quotation/close.png": "d810",
	"./quotation/cnCover.png": "2b79",
	"./quotation/cnDetailBg.png": "fb8d",
	"./quotation/cn_quotaIcon.png": "8291",
	"./quotation/empty@2x.png": "2f0a",
	"./quotation/empty@3x.png": "6969",
	"./quotation/empty_order_list@2x.png": "b21a",
	"./quotation/empty_order_list@3x.png": "2eda",
	"./quotation/hk1_global_bg.png": "0869",
	"./quotation/hk1_global_quotaIcon.png": "a234",
	"./quotation/hk1_mainland_bg.png": "dd47",
	"./quotation/hk1_mainland_quotaIcon.png": "bd47",
	"./quotation/hkCover.png": "97d4",
	"./quotation/hkCoverGlobal.png": "7434",
	"./quotation/hkDetailBg.png": "7b29",
	"./quotation/hkLv1Cover.png": "656f",
	"./quotation/hkLv1CoverGlobal.png": "648b",
	"./quotation/hk_active@2x.png": "e6bd",
	"./quotation/hk_active@3x.png": "124f",
	"./quotation/hk_inactive@2x.png": "358c",
	"./quotation/hk_inactive@3x.png": "1a66",
	"./quotation/hk_lv1_active@2x.png": "73e4",
	"./quotation/hk_lv1_active@3x.png": "ee0d",
	"./quotation/hk_lv1_product@2x.png": "cc23",
	"./quotation/hk_lv1_product@3x.png": "3201",
	"./quotation/hk_lv1_product_global@2x.png": "ace9",
	"./quotation/hk_lv1_product_global@3x.png": "8794",
	"./quotation/hk_product@2x.png": "42c5",
	"./quotation/hk_product@3x.png": "c302",
	"./quotation/hk_product_global@2x.png": "034e",
	"./quotation/hk_product_global@3x.png": "fb3b",
	"./quotation/hk_quotaIcon.png": "0243",
	"./quotation/icon_checked.png": "e35e",
	"./quotation/icon_close.png": "d02f",
	"./quotation/icon_copy.png": "0241",
	"./quotation/icon_payment.png": "b913",
	"./quotation/icon_unchecked.png": "5e94",
	"./quotation/list_10_tc.png": "0027",
	"./quotation/list_10_zh.png": "440d",
	"./quotation/list_11_tc.png": "f2b6",
	"./quotation/list_11_zh.png": "23a2",
	"./quotation/list_12_tc.png": "41f2",
	"./quotation/list_12_zh.png": "607f",
	"./quotation/list_1_tc.png": "5758",
	"./quotation/list_1_zh.png": "1eb2",
	"./quotation/list_2_tc.png": "54ae",
	"./quotation/list_2_zh.png": "ccf5",
	"./quotation/list_3_tc.png": "bf7be",
	"./quotation/list_3_zh.png": "f5c7",
	"./quotation/list_4_tc.png": "5396",
	"./quotation/list_4_zh.png": "fc7a",
	"./quotation/list_5_tc.png": "497c",
	"./quotation/list_5_zh.png": "ceaf",
	"./quotation/list_6_tc.png": "d70b",
	"./quotation/list_6_zh.png": "0038",
	"./quotation/list_7_tc.png": "c4f8",
	"./quotation/list_7_zh.png": "778b",
	"./quotation/list_8_tc.png": "ec4d",
	"./quotation/list_8_zh.png": "19dc",
	"./quotation/list_9_tc.png": "fbfb",
	"./quotation/list_9_zh.png": "9111",
	"./quotation/list_hk1_1_tc.png": "77af",
	"./quotation/list_hk1_1_zh.png": "c30c",
	"./quotation/list_hk1_2_tc.png": "a00a",
	"./quotation/list_hk1_2_zh.png": "56ba",
	"./quotation/list_hk1_3_tc.png": "af57",
	"./quotation/list_hk1_3_zh.png": "e045",
	"./quotation/list_hk_lv1_global.png": "6236",
	"./quotation/list_hk_lv1_mainland.png": "42b3",
	"./quotation/sign_right.png": "b309",
	"./quotation/sign_us.png": "a866",
	"./quotation/success_icon@2x.png": "f9bb",
	"./quotation/success_icon@3x.png": "41e6",
	"./quotation/us-quotation-popup-bg@2x.png": "61d0",
	"./quotation/us-quotation-popup-bg@3x.png": "11f3",
	"./quotation/us-quotation-popup-notpi@2x.png": "a394",
	"./quotation/us-quotation-popup-notpi@3x.png": "81eb",
	"./quotation/us-quotation-popup-pi@2x.png": "6256",
	"./quotation/us-quotation-popup-pi@3x.png": "2764",
	"./quotation/usCover.png": "3ecb",
	"./quotation/usDetailBg.png": "474e",
	"./quotation/us_active@2x.png": "adad",
	"./quotation/us_active@3x.png": "d5de",
	"./quotation/us_inactive@2x.png": "7154",
	"./quotation/us_inactive@3x.png": "8047",
	"./quotation/us_product@2x.png": "b147",
	"./quotation/us_product@3x.png": "8f4f",
	"./quotation/us_quotaIcon.png": "d5b7d",
	"./redPacket/arrow_left.png": "007b",
	"./redPacket/arrow_right.png": "36bd",
	"./redPacket/banner_zhCn.png": "b0a6",
	"./redPacket/banner_zhTc.png": "5268",
	"./redPacket/bg01_1_zhCn.png": "b9fc",
	"./redPacket/bg01_1_zhTc.png": "5222",
	"./redPacket/bg01_zhCn.png": "9f68",
	"./redPacket/bg01_zhTc.png": "ad84",
	"./redPacket/bg02_zhCn.png": "c7dd",
	"./redPacket/bg02_zhTc.png": "c083",
	"./redPacket/bg03.png": "6045",
	"./redPacket/bg03_1.png": "5eb8",
	"./redPacket/bg03_1_zhTc.png": "638f",
	"./redPacket/bg03_zhTc.png": "0c03",
	"./redPacket/bg04.png": "e9bf",
	"./redPacket/btn.png": "1b55",
	"./redPacket/btn01.png": "f10c",
	"./redPacket/btn02.png": "8c64",
	"./redPacket/btn04.png": "470d",
	"./redPacket/hand.png": "9c28",
	"./redPacket/hb_zhCn.png": "d391",
	"./redPacket/hb_zhTc.png": "3d03",
	"./redPacket/icon_close.png": "b7cd",
	"./redPacket/icon_finish.png": "b7a2",
	"./redPacket/lottie/img_0.png": "3ea1",
	"./redPacket/lottie/img_1.png": "6ead",
	"./redPacket/lottie/img_2.png": "624a",
	"./redPacket/qian_bg_zhCn.png": "d6a7",
	"./redPacket/qian_bg_zhTc.png": "7ed5",
	"./redPacket/qian_box_bg_zhCn.png": "9227",
	"./redPacket/qian_box_bg_zhTc.png": "8f5d",
	"./redPacket/qrCode_zhCn.png": "c96d",
	"./redPacket/qrCode_zhTc.png": "3b81",
	"./redPacket/red_packet.png": "9126",
	"./redPacket/red_packet_x2.png": "b81c",
	"./redPacket/red_packet_x4.png": "db0b",
	"./redPacket/rule_zhCn.png": "45e1",
	"./redPacket/rule_zhTc.png": "1479",
	"./redPacket/text/show_cn_text_1.png": "7a22",
	"./redPacket/text/show_cn_text_10.png": "a07c",
	"./redPacket/text/show_cn_text_11.png": "3cfc",
	"./redPacket/text/show_cn_text_12.png": "4d26",
	"./redPacket/text/show_cn_text_13.png": "93bf",
	"./redPacket/text/show_cn_text_14.png": "64d8",
	"./redPacket/text/show_cn_text_15.png": "107b",
	"./redPacket/text/show_cn_text_2.png": "dd68",
	"./redPacket/text/show_cn_text_3.png": "d715",
	"./redPacket/text/show_cn_text_4.png": "18af",
	"./redPacket/text/show_cn_text_5.png": "c118",
	"./redPacket/text/show_cn_text_6.png": "b297",
	"./redPacket/text/show_cn_text_7.png": "1589",
	"./redPacket/text/show_cn_text_8.png": "4367",
	"./redPacket/text/show_cn_text_9.png": "6706",
	"./redPacket/text/show_tc_text_1.png": "a528",
	"./redPacket/text/show_tc_text_10.png": "0361",
	"./redPacket/text/show_tc_text_11.png": "f0ab",
	"./redPacket/text/show_tc_text_12.png": "7a8c",
	"./redPacket/text/show_tc_text_13.png": "ae05",
	"./redPacket/text/show_tc_text_14.png": "15fa",
	"./redPacket/text/show_tc_text_15.png": "9a93",
	"./redPacket/text/show_tc_text_2.png": "6bfe",
	"./redPacket/text/show_tc_text_3.png": "bdaa",
	"./redPacket/text/show_tc_text_4.png": "3059",
	"./redPacket/text/show_tc_text_5.png": "d227",
	"./redPacket/text/show_tc_text_6.png": "8711",
	"./redPacket/text/show_tc_text_7.png": "268b",
	"./redPacket/text/show_tc_text_8.png": "d572",
	"./redPacket/text/show_tc_text_9.png": "8d0d",
	"./ruiyin/bg@2x.png": "b553",
	"./ruiyin/bg@3x.png": "28d0",
	"./ruiyin/logo@2x.png": "c525",
	"./ruiyin/logo@3x.png": "6467",
	"./signature/close.png": "fdaa",
	"./signature/icon_hyt_success@2x.png": "9f32",
	"./signature/icon_hyt_success@3x.png": "6b5a",
	"./signature/icon_success@2x.png": "d444",
	"./signature/icon_success@3x.png": "790b",
	"./signature/more.png": "c3a6",
	"./starStockOpenAccount/assessment_pic@2x.png": "80ab",
	"./starStockOpenAccount/assessment_pic@3x.png": "be12",
	"./starStockOpenAccount/cancel-icon.png": "b1b3",
	"./starStockOpenAccount/icon1@2x.png": "9bd4",
	"./starStockOpenAccount/icon1@3x.png": "0099",
	"./starStockOpenAccount/icon2@2x.png": "acf8",
	"./starStockOpenAccount/icon2@3x.png": "d9b4",
	"./starStockOpenAccount/icon3@2x.png": "d9f5",
	"./starStockOpenAccount/icon3@3x.png": "cba6",
	"./starStockOpenAccount/icon4@2x.png": "36d7",
	"./starStockOpenAccount/icon4@3x.png": "59e0",
	"./starStockOpenAccount/icon5@2x.png": "013d",
	"./starStockOpenAccount/icon5@3x.png": "a929",
	"./starStockOpenAccount/icon_card_play.png": "6e8c",
	"./starStockOpenAccount/icon_card_suspend.png": "3507",
	"./startAccount/advantage.png": "8fda",
	"./startAccount/advantage1.png": "10c1b",
	"./startAccount/advantage2.png": "1734",
	"./startAccount/advantage3.png": "27dc",
	"./startAccount/advantage4.png": "315f",
	"./startAccount/advantage5.png": "b5f1",
	"./startAccount/advantage6.png": "cf5b",
	"./startAccount/advantage7.png": "c4cf",
	"./startAccount/advantage8.png": "aec9",
	"./startAccount/bg-1-black.png": "7642",
	"./startAccount/bg-1.png": "58d2",
	"./startAccount/bg.png": "16a5",
	"./startAccount/bg1.png": "f88f",
	"./startAccount/bg_title.png": "848f",
	"./startAccount/full_bg.png": "fd0f",
	"./startAccount/icon_card.png": "d735",
	"./startAccount/icon_edda.png": "82244",
	"./startAccount/icon_market.png": "67d9",
	"./startAccount/icon_stock.png": "b3db",
	"./startAccount/icon_trade_bainjie.png": "d255",
	"./startAccount/icon_trade_new.png": "0dd3",
	"./startAccount/icon_trade_qixia.png": "1359",
	"./startAccount/icon_trade_yuyue.png": "7942",
	"./startAccount/one_account.png": "6b9a",
	"./startAccount/percent/pic_number_10.png": "5efc",
	"./startAccount/percent/pic_number_10_black.png": "e4b3",
	"./startAccount/percent/pic_number_40.png": "e203",
	"./startAccount/percent/pic_number_40_black.png": "8782",
	"./startAccount/percent/pic_number_60.png": "77c5",
	"./startAccount/percent/pic_number_60_black.png": "9cd9",
	"./startAccount/percent/pic_number_70.png": "3dea",
	"./startAccount/percent/pic_number_70_black.png": "b32a",
	"./startAccount/percent/pic_number_80.png": "e855",
	"./startAccount/percent/pic_number_80_black.png": "5f01",
	"./startAccount/percent/pic_number_90.png": "ff46",
	"./startAccount/percent/pic_number_90_black.png": "8cdfc",
	"./startAccount/slogan_zhCn.png": "3b36",
	"./startAccount/slogan_zhTc.png": "ca54",
	"./startAccount/wallet_bg.png": "1c13",
	"./stockReport/cancel@2x.png": "fd083",
	"./stockReport/cancel@3x.png": "7dc2",
	"./stockReport/ipo-team-icon@2x.png": "a2ee",
	"./stockReport/ipo-team-icon@3x.png": "1263",
	"./stockReport/next@2x.png": "827d",
	"./stockReport/next@3x.png": "0a51",
	"./stockReport/remind@2x.png": "6b4b",
	"./stockReport/remind@3x.png": "6e77",
	"./stockReport/sort-down.png": "c665",
	"./stockReport/sort-down__active.png": "2496",
	"./stockReport/sort-up.png": "a6df",
	"./stockReport/sort-up__active.png": "77d1",
	"./stockReport/top_bg.png": "e3a1",
	"./stockTransferIn/icon_agreement_normal@3x.png": "603f",
	"./stockTransferIn/icon_agreement_select@3x.png": "bf7c",
	"./stockTransferIn/icon_arrow_left.png": "5c63",
	"./stockTransferIn/icon_flag_chn.png": "08f2",
	"./stockTransferIn/icon_flag_hk.png": "d195",
	"./stockTransferIn/icon_flag_us.png": "1364",
	"./stockTransferIn/icon_line_list.png": "2d12",
	"./stockTransferIn/icon_shares_add@3x.png": "9985",
	"./stockTransferIn/icon_tick_select@3x.png": "e6b1",
	"./stockTransferIn/icon_zhuancang_delete@3x.png": "7289",
	"./stockTransferIn/step1-t.png": "3ad4",
	"./stockTransferIn/step1.png": "6038",
	"./stockTransferIn/step2-d.png": "ff01",
	"./stockTransferIn/step2-t.png": "399d",
	"./stockTransferIn/step2.png": "0588",
	"./stockTransferIn/step3-d.png": "175f",
	"./stockTransferIn/step3-t.png": "e61c",
	"./stockTransferIn/step4-d.png": "367a9",
	"./stockTransferIn/union.png": "6e9f8",
	"./stratAccountTZYM/bg.png": "de94",
	"./stratAccountTZYM/card_1@3x.png": "bf68",
	"./stratAccountTZYM/card_2@3x.png": "7743",
	"./stratAccountTZYM/ellipse@3x.png": "becd",
	"./stratAccountTZYM/panking_1@3x.png": "67c8",
	"./stratAccountTZYM/panking_2@3x.png": "3217",
	"./stratAccountTZYM/panking_3@3x.png": "fb90",
	"./stratAccountTZYM/text1_zhCn@3x.png": "744a",
	"./stratAccountTZYM/text1_zhTc@3x.png": "d6f6",
	"./stratAccountTZYM/text2_zhCn@3x.png": "746d",
	"./stratAccountTZYM/text2_zhTc@3x.png": "5c85",
	"./stratAccountTZYM/title_zhCn@3x.png": "834e",
	"./stratAccountTZYM/title_zhTc@3x.png": "5736",
	"./stratAccountTZYM/vector@3x.png": "4856",
	"./tradeMarket/arrow.png": "9f87",
	"./tradeMarket/copy.png": "9db8",
	"./tradeMarket/union.png": "af81",
	"./tradeRecom/TickSquare@2x.png": "aaff",
	"./tradeRecom/TickSquare@3x.png": "a1cc",
	"./tradeRecom/about-i@2x.png": "b056",
	"./tradeRecom/about-i@3x.png": "4b6f",
	"./tradeRecom/ai-calculating-tomorrow@2x.png": "40bc",
	"./tradeRecom/ai-calculating-tomorrow@3x.png": "a6a6",
	"./tradeRecom/arrow_next@2x.png": "7cef",
	"./tradeRecom/arrow_next@3x.png": "357a",
	"./tradeRecom/bar-arrow-right.png": "f047",
	"./tradeRecom/bar-arrow@2x.png": "4422",
	"./tradeRecom/bar-arrow@3x.png": "7f6f",
	"./tradeRecom/details-bg@2x.png": "51c0",
	"./tradeRecom/details-bg@3x.png": "6cd6",
	"./tradeRecom/direction-1@2x.png": "569a",
	"./tradeRecom/direction-1@3x.png": "2425",
	"./tradeRecom/direction-2@2x.png": "6e26",
	"./tradeRecom/direction-2@3x.png": "a482",
	"./tradeRecom/direction-3@2x.png": "d008",
	"./tradeRecom/direction-3@3x.png": "6a6f",
	"./tradeRecom/fall-1@2x.png": "e7d2",
	"./tradeRecom/fall-1@3x.png": "0386",
	"./tradeRecom/fall-2@2x.png": "44d3",
	"./tradeRecom/fall-2@3x.png": "286d",
	"./tradeRecom/fall-3@2x.png": "72a3",
	"./tradeRecom/fall-3@3x.png": "7452",
	"./tradeRecom/fall-4@2x.png": "7579",
	"./tradeRecom/fall-4@3x.png": "9413",
	"./tradeRecom/gotoTop@2x.png": "c2df",
	"./tradeRecom/gotoTop@3x.png": "6bb5",
	"./tradeRecom/icon-close@2x.png": "c35c",
	"./tradeRecom/icon-close@3x.png": "3deab",
	"./tradeRecom/icon-optional-view@2x.png": "197c",
	"./tradeRecom/icon-optional-view@3x.png": "7a16",
	"./tradeRecom/icon-ranking-1@2x.png": "2cb3",
	"./tradeRecom/icon-ranking-1@3x.png": "1a2b",
	"./tradeRecom/icon-ranking-2@2x.png": "4e87",
	"./tradeRecom/icon-ranking-2@3x.png": "05e8",
	"./tradeRecom/icon-ranking-3@2x.png": "07da",
	"./tradeRecom/icon-ranking-3@3x.png": "d5ac",
	"./tradeRecom/icon-ranking-4@2x.png": "24eb",
	"./tradeRecom/icon-ranking-4@3x.png": "635c",
	"./tradeRecom/icon-ranking-5@2x.png": "a19e",
	"./tradeRecom/icon-ranking-5@3x.png": "c753",
	"./tradeRecom/icon-stockpicker-calculating-done@2x.png": "fe23",
	"./tradeRecom/icon-stockpicker-calculating-done@3x.png": "df68",
	"./tradeRecom/icon-stockpicker-calculating@2x.png": "7299",
	"./tradeRecom/icon-stockpicker-calculating@3x.png": "7570",
	"./tradeRecom/icon-stockpicker-generating-done@2x.png": "ff20",
	"./tradeRecom/icon-stockpicker-generating-done@3x.png": "7d44",
	"./tradeRecom/icon-stockpicker-generating@2x.png": "a608",
	"./tradeRecom/icon-stockpicker-generating@3x.png": "481a",
	"./tradeRecom/icon-stockpicker-loading@2x.png": "1aca",
	"./tradeRecom/icon-stockpicker-loading@3x.png": "dde9",
	"./tradeRecom/icon-stockpicker-training-done@2x.png": "360f",
	"./tradeRecom/icon-stockpicker-training-done@3x.png": "b9b9",
	"./tradeRecom/icon-stockpicker-training@2x.png": "3ee1",
	"./tradeRecom/icon-stockpicker-training@3x.png": "c2b0",
	"./tradeRecom/icon_download@2x.png": "40a2",
	"./tradeRecom/icon_download@3x.png": "5a17",
	"./tradeRecom/icon_flag_hk@2x.png": "cf10",
	"./tradeRecom/icon_flag_hk@3x.png": "428d",
	"./tradeRecom/icon_flag_us@2x.png": "b967",
	"./tradeRecom/icon_flag_us@3x.png": "4372c",
	"./tradeRecom/icon_ipo_suggestion_1@2x.png": "060a",
	"./tradeRecom/icon_ipo_suggestion_1@3x.png": "171b",
	"./tradeRecom/icon_ipo_suggestion_2@2x.png": "b5ee",
	"./tradeRecom/icon_ipo_suggestion_2@3x.png": "973d",
	"./tradeRecom/icon_ipo_suggestion_3@2x.png": "aa67",
	"./tradeRecom/icon_ipo_suggestion_3@3x.png": "9e8f",
	"./tradeRecom/icon_ipo_suggestion_4@2x.png": "d808",
	"./tradeRecom/icon_ipo_suggestion_4@3x.png": "79d0",
	"./tradeRecom/img_ai_test_stock_bg@2x.png": "73b8",
	"./tradeRecom/img_ai_test_stock_bg@3x.png": "8991",
	"./tradeRecom/img_ai_test_stock_card_bg@2x.png": "16ef9",
	"./tradeRecom/img_ai_test_stock_card_bg@3x.png": "cc4d",
	"./tradeRecom/list-bg@2x.png": "f1f7",
	"./tradeRecom/list-bg@3x.png": "7034",
	"./tradeRecom/logo@2x.png": "7bf6",
	"./tradeRecom/logo@3x.png": "cda1",
	"./tradeRecom/rise-1@2x.png": "f641",
	"./tradeRecom/rise-1@3x.png": "1360",
	"./tradeRecom/rise-2@2x.png": "fd7c",
	"./tradeRecom/rise-2@3x.png": "1eaf",
	"./tradeRecom/rise-3@2x.png": "dbd4",
	"./tradeRecom/rise-3@3x.png": "cec3",
	"./tradeRecom/rise-4@2x.png": "e265",
	"./tradeRecom/rise-4@3x.png": "7629",
	"./tradeRecom/robot@2x.png": "ac9e",
	"./tradeRecom/robot@3x.png": "d135",
	"./tradeRecom/scroll-down@2x.png": "4a98",
	"./tradeRecom/scroll-down@3x.png": "2894",
	"./tradeRecom/search-icon@2x.png": "0d0c",
	"./tradeRecom/search-icon@3x.png": "abb0",
	"./tradeRecom/share@2x.png": "451a",
	"./tradeRecom/share@3x.png": "1d9d",
	"./tradeRecom/star-ai/chat-loading@2x.png": "a50b",
	"./tradeRecom/star-ai/chat-loading@3x.png": "7a15",
	"./tradeRecom/star-ai/chat-new-chat@2x.png": "b1bf",
	"./tradeRecom/star-ai/chat-new-chat@3x.png": "997e",
	"./tradeRecom/star-ai/chat-sidebar@2x.png": "e221",
	"./tradeRecom/star-ai/chat-sidebar@3x.png": "aee8",
	"./tradeRecom/star-ai/deepseek-logo@2x.png": "f3bb",
	"./tradeRecom/star-ai/deepseek-logo@3x.png": "80061",
	"./tradeRecom/star-ai/deepseek-send@2x.png": "6dc3",
	"./tradeRecom/star-ai/deepseek-send@3x.png": "876e",
	"./tradeRecom/star-ai/deepseek-slogan@2x.png": "c7e2",
	"./tradeRecom/star-ai/deepseek-slogan@3x.png": "72a6",
	"./tradeRecom/star-ai/icon-ai-change-line@2x.png": "7af7",
	"./tradeRecom/star-ai/icon-ai-change-line@3x.png": "7e86",
	"./tradeRecom/star-ai/icon-ai-measure-line@2x.png": "4f4b",
	"./tradeRecom/star-ai/icon-ai-measure-line@3x.png": "786d",
	"./tradeRecom/star-ai/icon-ai-picker-line@2x.png": "e5e4",
	"./tradeRecom/star-ai/icon-ai-picker-line@3x.png": "800b",
	"./tradeRecom/star-ai/icon-ai-xiaojie-line@2x.png": "add6",
	"./tradeRecom/star-ai/icon-ai-xiaojie-line@3x.png": "b1fa",
	"./tradeRecom/star-ai/icon-ai-xiaojie@2x.png": "4d74",
	"./tradeRecom/star-ai/icon-ai-xiaojie@3x.png": "2e1f",
	"./tradeRecom/star-ai/icon_ai_change@2x.png": "89b7",
	"./tradeRecom/star-ai/icon_ai_change@3x.png": "f42a",
	"./tradeRecom/star-ai/icon_ai_more@2x.png": "2994",
	"./tradeRecom/star-ai/icon_ai_more@3x.png": "0154",
	"./tradeRecom/star-ai/icon_ai_news@2x.png": "ba46",
	"./tradeRecom/star-ai/icon_ai_news@3x.png": "40df",
	"./tradeRecom/star-ai/sidebar-close@2x.png": "939e",
	"./tradeRecom/star-ai/sidebar-close@3x.png": "91a2",
	"./tradeRecom/star-ai/star-ai-bg@2x.png": "f432",
	"./tradeRecom/star-ai/star-ai-bg@3x.png": "93bb",
	"./tradeRecom/star-ai/star-ai-card@2x.png": "2063",
	"./tradeRecom/star-ai/star-ai-card@3x.png": "592b",
	"./tradeRecom/vector-1@2x.png": "0abc",
	"./tradeRecom/vector-1@3x.png": "c46a",
	"./tradeRecom/vector-2@2x.png": "5cd5",
	"./tradeRecom/vector-2@3x.png": "8458",
	"./tradeRecom/view-history@2x.png": "5554",
	"./tradeRecom/view-history@3x.png": "379f",
	"./tradeStatement/icon_arrow_down.png": "e540",
	"./tradeStatement/icon_arrow_down_black.png": "1b26",
	"./tradeStatement/icon_arrow_next.png": "1e4c",
	"./tradeStatement/icon_arrow_next_black.png": "6cd3",
	"./tradeStatement/icon_data_empty.png": "396a",
	"./tradeStatement/icon_data_empty_black.png": "60e5",
	"./tradeStatement/icon_my_setup.png": "7c10",
	"./tradeStatement/icon_my_setup_black.png": "ea9e",
	"./tradeStatement/icon_popup_close.png": "4c14",
	"./tradeStatement/icon_popup_close_black.png": "e622",
	"./userInformation/AuditFailed.png": "94b9",
	"./userInformation/CreditCard.png": "f910",
	"./userInformation/UnderReview.png": "43b2",
	"./userInformation/addr_img.png": "04b8",
	"./userInformation/address_bg.png": "fc270",
	"./userInformation/arrow_below.png": "9ad8",
	"./userInformation/arrow_right.png": "f394",
	"./userInformation/arrow_right1.png": "05fd",
	"./userInformation/arrow_up.png": "e4ea",
	"./userInformation/coalGas.png": "1ef2",
	"./userInformation/electricity.png": "86b6",
	"./userInformation/icon_add.png": "8024",
	"./userInformation/icon_checked.png": "6aea",
	"./userInformation/icon_delete.png": "7d54",
	"./userInformation/icon_failed.png": "7aea",
	"./userInformation/icon_info.png": "b945",
	"./userInformation/icon_success.png": "d707",
	"./userInformation/icon_tick_select.png": "114d",
	"./userInformation/icon_unchecked.png": "38e1",
	"./userInformation/icon_upload.png": "e12e",
	"./userInformation/licensedInstitution.png": "1d65",
	"./userInformation/pic_review_failed.png": "f386",
	"./userInformation/pic_under_review.png": "5a8c",
	"./userInformation/status_success.png": "c300",
	"./userInformation/telecom.png": "b8da",
	"./userInformation/tips_bg_green.png": "ba08",
	"./userInformation/tips_bg_red.png": "cae3",
	"./vaccines/agree.png": "2684",
	"./vaccines/close.png": "e4cc",
	"./vaccines/downQR.png": "dd1c",
	"./vaccines/oval.png": "3689",
	"./vaccines/routine/c-f_bg.png": "3ff4",
	"./vaccines/routine/c-j_bg.png": "8895",
	"./vaccines/routine/r1.png": "624e",
	"./vaccines/routine/r2.png": "bd27",
	"./vaccines/routine/r3.png": "efbe",
	"./vaccines/routine/r4.png": "a0cd",
	"./vaccines/routine/r5.png": "6b1b",
	"./vaccines/routine/r6.png": "b798",
	"./vaccines/routine/r7.png": "1f10",
	"./vaccines/routine/rQR_f.png": "7695",
	"./vaccines/routine/rQR_j.png": "6bee",
	"./vaccines/routine/rf1.png": "fb4e",
	"./vaccines/routine/rf2.png": "61bd",
	"./vaccines/routine/rf3.png": "9501",
	"./vaccines/routine/rf4.png": "142a",
	"./vaccines/routine/rf5.png": "68e4",
	"./vaccines/routine/rf6.png": "a375",
	"./vaccines/routine/rf7.png": "9b25",
	"./vaccines/routine/select.png": "6917",
	"./vaccines/unlogin/rt/agree.png": "23f1",
	"./vaccines/unlogin/rt/oval.png": "07cf",
	"./vaccines/unlogin/rt/r1.png": "b2b2",
	"./vaccines/unlogin/rt/r2.png": "0dbc",
	"./vaccines/unlogin/rt/r3.png": "e870",
	"./vaccines/unlogin/rt/r4.png": "6a36",
	"./vaccines/unlogin/rt/rf1.png": "ab38",
	"./vaccines/unlogin/rt/rf2.png": "728d",
	"./vaccines/unlogin/rt/rf3.png": "8560",
	"./vaccines/unlogin/rt/rf4.png": "7a7a",
	"./vaccines/unlogin/rt/sj.png": "7219",
	"./vaccines/unlogin/vip/agree.png": "1bb8",
	"./vaccines/unlogin/vip/oval.png": "2d6d",
	"./vaccines/unlogin/vip/sj.png": "dec5",
	"./vaccines/unlogin/vip/v1.png": "6de1",
	"./vaccines/unlogin/vip/v2.png": "11c2",
	"./vaccines/unlogin/vip/v3.png": "6252f",
	"./vaccines/unlogin/vip/v4.png": "1238",
	"./vaccines/unlogin/vip/vf1.png": "9bcb",
	"./vaccines/unlogin/vip/vf2.png": "569f",
	"./vaccines/unlogin/vip/vf3.png": "8655b",
	"./vaccines/unlogin/vip/vf4.png": "11a7",
	"./vaccines/vip/g-f_bg.png": "cb80",
	"./vaccines/vip/g-j_bg.png": "82f6",
	"./vaccines/vip/select.png": "fbf7",
	"./vaccines/vip/v1.png": "558d",
	"./vaccines/vip/v2.png": "174b",
	"./vaccines/vip/v3.png": "408a",
	"./vaccines/vip/v4.png": "0d6c",
	"./vaccines/vip/v5.png": "7641",
	"./vaccines/vip/v6.png": "4ed6",
	"./vaccines/vip/v7.png": "b876",
	"./vaccines/vip/vQR_f.png": "516a",
	"./vaccines/vip/vQR_j.png": "15e2",
	"./vaccines/vip/vf1.png": "aba6",
	"./vaccines/vip/vf2.png": "bc6cd",
	"./vaccines/vip/vf3.png": "be90",
	"./vaccines/vip/vf4.png": "ebaf",
	"./vaccines/vip/vf5.png": "4f8a",
	"./vaccines/vip/vf6.png": "7496",
	"./vaccines/vip/vf7.png": "a73d",
	"./wealthActivity/CMHKBEFORE_02_zhCn.png": "613d",
	"./wealthActivity/CMHKBEFORE_02_zhTc.png": "e2d2",
	"./wealthActivity/CMHK_01_zhCn.png": "037e",
	"./wealthActivity/CMHK_01_zhTc.png": "3e06",
	"./wealthActivity/CMHK_02_zhCn.png": "71fc",
	"./wealthActivity/CMHK_02_zhTc.png": "8a83",
	"./wealthActivity/CMHK_03_zhCn.png": "37cf",
	"./wealthActivity/CMHK_03_zhTc.png": "2103",
	"./wealthActivity/bgimg.png": "0277",
	"./wealthList/arrow.png": "fc31",
	"./wealthList/icon1.png": "9d33",
	"./wealthList/icon2.png": "d8a8",
	"./wealthList/icon3.png": "c382",
	"./wealthList/lcbannerzhCn.png": "5bd5",
	"./wealthList/lcbannerzhTc.png": "2467",
	"./zhuancang/bottom-btn.png": "30e3",
	"./zhuancang/img1.png": "f300",
	"./zhuancang/img1_zhTc.png": "8d90",
	"./zhuancang/img2.png": "3fe4",
	"./zhuancang/img2_zhTc.png": "9fa6",
	"./zhuancang/img3.png": "abc9",
	"./zhuancang/img3_zhTc.png": "484a",
	"./zhuancang/img4.png": "0670",
	"./zhuancang/img4_zhTc.png": "dfd1",
	"./zhuancang/img5.png": "1763",
	"./zhuancang/img5_zhTc.png": "21ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";